var _circle, _circle2, _circle3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgNotice(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77,
    cy: 75.5,
    r: 70,
    stroke: "#FFD4D6",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77,
    cy: 75.5,
    r: 75,
    stroke: "#FFD4D6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 75.5,
    r: 63.5,
    stroke: "#FFD4D6",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5851_117517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 75C16.5 41.8629 43.3629 15 76.5 15C109.637 15 136.5 41.8629 136.5 75C136.5 108.137 109.637 135 76.5 135C43.3629 135 16.5 108.137 16.5 75Z",
    fill: "#F8696E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5851_117517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.0645 108C65.2051 108 54.377 101.812 48.4473 91.5C42.5176 81.3164 42.5176 68.8125 48.4473 58.5C54.377 48.3164 65.2051 42 77.0645 42C88.7949 42 99.623 48.3164 105.553 58.5C111.482 68.8125 111.482 81.3164 105.553 91.5C99.623 101.812 88.7949 108 77.0645 108ZM80.1582 58.5H73.9707V61.5938V76.0312V79.125H80.1582V76.0312V61.5938V58.5ZM73.9707 89.4375H80.1582V83.25H73.9707V89.4375Z",
    fill: "url(#paint0_linear_5851_117517)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5851_117517",
    x: 20,
    y: 26,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.924056 0 0 0 0 0.224592 0 0 0 0 0.249049 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5851_117517"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5851_117517",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5851_117517",
    x1: 77,
    y1: 42,
    x2: 77,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDBDB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5851_117517"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 75C16.5 41.8629 43.3629 15 76.5 15C109.637 15 136.5 41.8629 136.5 75C136.5 108.137 109.637 135 76.5 135C43.3629 135 16.5 108.137 16.5 75Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNotice);
export default __webpack_public_path__ + "static/media/img_notice.d93ca3c213dc38e1ebe3ea5cccbbe2d9.svg";
export { ForwardRef as ReactComponent };